import { useState } from "react";
import Select from "react-select";


const Majorselector = ({onSelectionChange}) => {
  const [selectedMajor, setSelectedMajor] = useState([]);

  const majorOptions = [
  { value: "Accounting", label: "Accounting" },
  { value: "Advertising", label: "Advertising" },
  { value: "African studies", label: "African studies" },
  { value: "Anthropology", label: "Anthropology" }, 
  { value: "Arabic studies", label: "Arabic studies" },
  { value: "Architecture", label: "Architecture" },
  { value: "Art", label: "Art" },
  { value: "Art and technology", label: "Art and technology" },
  { value: "Art history", label: "Art history" },
  { value: "Asian studies", label: "Asian studies" },
  { value: "Biochemistry", label: "Biochemistry" },
  { value: "Bioengineering", label: "Bioengineering" },
  { value: "Biology", label: "Biology" },
  { value: "Black studies", label: "Black studies" },
  { value: "Business administration", label: "Business administration" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Child behavioral health", label: "Child behavioral health" },
  { value: "Chinese", label: "Chinese" },
  { value: "Cinema studies", label: "Cinema studies" },
  { value: "Classical civilization", label: "Classical civilization" },
  { value: "Classics", label: "Classics" },
  { value: "Climate studies", label: "Climate studies" },
  { value: "Comics and cartoon studies", label: "Comics and cartoon studies" },
  { value: "Commerce and society", label: "Commerce and society" },
  { value: "Communication disorders and sciences", label: "Communication disorders and sciences" },
  { value: "Comparative literature", label: "Comparative literature" },
  { value: "Computer and information technology", label: "Computer and information technology" },
  { value: "Computer science", label: "Computer science" },
  { value: "Creative writing", label: "Creative writing" },
  { value: "Criminology", label: "Criminology" },
  { value: "Cybersecurity", label: "Cybersecurity" },
  { value: "Dance", label: "Dance" },
  { value: "Data science", label: "Data science" },
  { value: "Digital humanities", label: "Digital humanities" },
  { value: "Disability studies", label: "Disability studies" },
  { value: "Earth sciences", label: "Earth sciences" },
  { value: "East Asian studies", label: "East Asian studies" },
  { value: "Economics", label: "Economics" },
  { value: "Educational foundations", label: "Educational foundations" },
  { value: "English", label: "English" },
  { value: "Entrepreneurship", label: "Entrepreneurship" },
  { value: "Environmental design", label: "Environmental design" },
  { value: "Environmental humanities", label: "Environmental humanities" },
  { value: "Environmental science", label: "Environmental science" },
  { value: "Environmental studies", label: "Environmental studies" },
  { value: "Ethics", label: "Ethics" },
  { value: "European studies", label: "European studies" },
  { value: "Family and human services", label: "Family and human services" },
  { value: "Folklore and public culture", label: "Folklore and public culture" },
  { value: "Food studies", label: "Food studies" },
  { value: "French", label: "French" },
  { value: "General social sciences", label: "General social sciences" },
  { value: "Geography", label: "Geography" },
  { value: "German", label: "German" },
  { value: "German and Scandinavian Studies", label: "German and Scandinavian Studies" },
  { value: "Global health", label: "Global health" },
  { value: "Global service", label: "Global service" },
  { value: "Global studies", label: "Global studies" },
  { value: "Greek", label: "Greek" },
  { value: "Historic preservation", label: "Historic preservation" },
  { value: "History", label: "History" },
  { value: "Human physiology", label: "Human physiology" },
  { value: "Humanities", label: "Humanities" },
  { value: "Indigenous, race, and ethnic studies", label: "Indigenous, race, and ethnic studies" },
  { value: "Interdisciplinary cognitive sciences", label: "Interdisciplinary cognitive sciences" },
  { value: "Interior architecture", label: "Interior architecture" },
  { value: "Italian", label: "Italian" },
  { value: "Japanese", label: "Japanese" },
  { value: "Jazz studies", label: "Jazz studies" },
  { value: "Journalism", label: "Journalism" },
  { value: "Judaic studies", label: "Judaic studies" },
  { value: "Korean", label: "Korean" },
  { value: "Landscape architecture", label: "Landscape architecture" },
  { value: "Latin", label: "Latin" },
  { value: "Latin American studies", label: "Latin American studies" },
  { value: "Latinx studies", label: "Latinx studies" },
  { value: "Legal studies", label: "Legal studies" },
  { value: "Linguistics", label: "Linguistics" },
  { value: "Marine biology", label: "Marine biology" },
  { value: "Mathematics", label: "Mathematics" },
  { value: "Mathematics and computer science", label: "Mathematics and computer science" },
  { value: "Media studies", label: "Media studies" },
  { value: "Medieval studies", label: "Medieval studies" },
  { value: "Middle East-North Africa studies", label: "Middle East-North Africa studies" },
  { value: "Multidisciplinary science", label: "Multidisciplinary science" },
  { value: "Multimedia", label: "Multimedia" },
  { value: "Music", label: "Music" },
  { value: "Music composition", label: "Music composition" },
  { value: "Music education", label: "Music education" },
  { value: "Music performance", label: "Music performance" },
  { value: "Music production", label: "Music production" },
  { value: "Music technology", label: "Music technology" },
  { value: "Native American and Indigenous studies", label: "Native American and Indigenous studies" },
  { value: "Neuroscience", label: "Neuroscience" },
  { value: "Nonprofit administration", label: "Nonprofit administration" },
  { value: "Philosophy", label: "Philosophy" },
  { value: "Physics", label: "Physics" },
  { value: "Planning, public policy and management", label: "Planning, public policy and management" },
  { value: "Political science", label: "Political science" },
  { value: "Popular music", label: "Popular music" },
  { value: "Product design", label: "Product design" },
  { value: "Psychology", label: "Psychology" },
  { value: "Public relations", label: "Public relations" },
  { value: "Queer studies", label: "Queer studies" },
  { value: "Religious studies", label: "Religious studies" },
  { value: "Romance languages", label: "Romance languages" },
  { value: "Russian, East European, and Eurasian studies", label: "Russian, East European, and Eurasian studies" },
  { value: "Scandinavian", label: "Scandinavian" },
  { value: "Science communication", label: "Science communication" },
  { value: "Sociology", label: "Sociology" },
  { value: "South Asian studies", label: "South Asian studies" },
  { value: "Southeast Asian studies", label: "Southeast Asian studies" },
  { value: "Spanish", label: "Spanish" },
  { value: "Spatial data science and technology", label: "Spatial data science and technology" },
  { value: "Special education", label: "Special education" },
  { value: "Sports business", label: "Sports business" },
  { value: "Sustainable business", label: "Sustainable business" },
  { value: "Theater arts", label: "Theater arts" },
  { value: "Women’s, Gender, and Sexuality Studies", label: "Women’s, Gender, and Sexuality Studies" },
  { value: "Writing, public speaking, and critical reasoning", label: "Writing, public speaking, and critical reasoning" },
  ];
  

  const handleChange = (selectedOptions) => {
    setSelectedMajor(selectedOptions);
    onSelectionChange(selectedOptions.map(option => option.value));

  };
  return (
    <Select isMulti
      options={majorOptions}
      value={selectedMajor}
      onChange={handleChange}
      id="Major"
      name="message"
    />
  );
};

export default Majorselector;